module.exports = __webpack_public_path__ + "img/turnpage-left-prev.635d63c2.svg";